import HomeRoute from "../../components/routes/HomeRoute";
import messages from "../../i18n/messages/es.json";

export default function Page() {
  return <HomeRoute locale="es" messages={messages} />;
}
